module.exports = __webpack_public_path__ + "static/media/km-history-chart-blurred.e827e56e.png";